import { useContextModal } from '@/components/Modal';
import { BellIcon } from '@heroicons/react/outline';
import { Alarmcenter } from './Alarmcenter';
import { useAlarmcenter } from './useAlarmcenter';

export const AlarmcenterTrigger = () => {
  const modal = useContextModal();
  const { stats, isLoading, readNotification, readAllNotifications } =
    useAlarmcenter();

  const handleClick = () => {
    modal.open([
      <Alarmcenter
        onClose={modal.close}
        readNotification={readNotification}
        readAllNotifications={readAllNotifications}
      />,
      {
        hasDefaultPadding: false,
        isSide: true,
      },
    ]);
  };
  return (
    <button onClick={handleClick}>
      <div className="relative flex items-center justify-center">
        <BellIcon
          strokeWidth={1.5}
          className="w-6 h-6 translate-y-1 text-gray-600"
        />
        {!isLoading && !!stats?.unread && stats?.unread > 0 && (
          <p className="absolute translate-x-2 -translate-y-2 text-xs text-white min-w-5 left-1 px-1 py-[2px] bg-red-500 rounded-full">
            {stats?.unread}
          </p>
        )}
      </div>
    </button>
  );
};
